import { LitElement } from 'lit';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin';
import { TriggerEventMixin } from '@common/lit/mixins/TriggerEventMixin';
import { TemplateTheme } from '@common/lit/TemplateResolver';
import * as templates from '@src/components/templates';
import { config } from '@src/config';
import { configStore } from '@src/store';

export class BaseComponent extends TemplatingMixin(TriggerEventMixin(LitElement, config.componentTagName), configStore.theme, templates) {
  constructor() {
    super();
    // This is important to support multiple themes (occl/tefOne).
    // If the theme gets changed in the configStore we must re-initialize the TemplateResolver,
    // otherwise it would stay on the theme default (which is "occl" here)
    configStore.subscribe((_, theme) => { this.setTemplatingTheme(theme as TemplateTheme); }, 'theme');
  }
}
